import React, { useState, useMemo } from 'react';
import { Tag, Typography, Input, Checkbox, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
// @ts-ignore
import { useModel } from 'umi';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
const defaultTestService = 'http://localhost:8080';
// 环境标志
const ENVTagColor = {
    dev: 'orange',
    qa: 'green',
    uat: '#87d068',
};
const EnvTag = () => {
    const { env, setApiPrefix, getApiPrefix } = useModel('system');
    const defaultPrefix = useMemo(() => getApiPrefix(), []);
    const [lock, setLock] = useState(false);
    const [prefix, setPrefix] = useState(defaultTestService + defaultPrefix);
    const [visible, setVisible] = useState(false);
    // 生产环境不显示标志
    if (env === 'prod') {
        return null;
    }
    const apply = (e) => {
        const { checked } = e.target;
        // check
        if (checked && !/^http:\/\//.test(prefix)) {
            message.error('无效的请求地址格式');
            return;
        }
        setLock(checked);
        setApiPrefix(checked ? prefix : defaultPrefix);
    };
    const content = (React.createElement("div", { className: styles.content },
        React.createElement("h4", null, "\u540E\u53F0\u8C03\u8BD5\u901A\u9053"),
        React.createElement(Typography.Text, { type: "secondary" }, "\u8BBE\u7F6E\u63A5\u53E3\u5730\u5740\uFF0C\u8BF7\u6C42\u8F6C\u53D1\u5230\u65B0\u7684\u540E\u53F0\u5730\u5740"),
        React.createElement("div", { className: styles.inputWrap },
            React.createElement(Input, { value: prefix, style: { width: 300 }, size: "small", disabled: lock, onChange: (e) => setPrefix(e.target.value) }),
            React.createElement(Checkbox, { checked: lock, onChange: apply }, "\u542F\u7528")),
        lock && (React.createElement("div", null,
            React.createElement(Typography.Text, { type: "secondary" },
                React.createElement(CheckOutlined, null),
                "\u8BBE\u7F6E\u6210\u529F\uFF0C\u8BF7\u786E\u8BA4\u8C03\u8BD5\u5730\u5740\u5DF2\u5F00\u542F\u8DE8\u57DF")))));
    return (React.createElement(HeaderDropdown, { overlay: content, placement: "bottomRight", visible: visible, onVisibleChange: setVisible, disabled: env === 'uat', trigger: ['click'] },
        React.createElement("span", { className: styles.action }, lock ? React.createElement(Tag, { color: "#f50" }, "\u8C03\u8BD5") : React.createElement(Tag, { color: ENVTagColor[env] }, env))));
};
export default EnvTag;
